import React, {Component} from 'react';
import styled from 'styled-components'
import PropTypes from 'prop-types'
// import {Switch} from "@smooth-ui/core-sc";
import {Backdrop, Block, Overlay, Portal} from "reakit";
import {Box, Flex, Image, Text} from 'rebass';
import chevronRight from '../../resources/img/icons/Chevron_2@1x.png'
import IosClose from 'react-ionicons/lib/IosClose'
import NotifcationsPanel from './NotificationsPanel'
const FilterOverlay = styled(Overlay)`
width: 100%;
height: 100%;
`;


class Notifications extends Component {

	state = {
		gender: '',
		grade: '',
		dorm: '',
		location: '',
		type: '',
		notification: false,
		// message: ''
	};

	componentDidMount() {
		if (localStorage.getItem('WAVE_NOTIFICATIONS') && localStorage.getItem('WAVE_NOTIFICATIONS') === 'true') {
			// this.setState({notification: true})
			// this.handleRequestNotification()
		}
		// let defaultId = this.props.firebase.id
		// let defaultId = this.props.firebase.admin.instanceId()
		// console.log('iid', defaultId)
		try {
			this.props.firebase.messaging.getToken().then(token => {
				// console.log('token', token)

				this.setState({notification: true})
			})

		} catch (e) {
			console.log(e)
		}


	}

	handleSelect = async (e) => {
		const {updateRequestNotification} = this.props;
		if (e.target.checked) {
			updateRequestNotification()
		} else {
			this.setState({notification: false});
			localStorage.setItem('WAVE_NOTIFICATIONS', false)

		}
		console.log('select')
	};


	render() {

		// const {notification, message} = this.state;
		return (
			<Overlay.Container>
				{overlay => (
					<Block>
						<Flex onClick={overlay.show} {...overlay}>
							<Box><Text ml={'7px'} fontWeight={600}>Notifications</Text></Box>
							<Box mr={'auto'}/>
							<Box><Image src={chevronRight}/> </Box>
						</Flex>
						<Backdrop use={[Portal, Overlay.Hide]} {...overlay} />
						<FilterOverlay use={Portal} {...overlay}>

							<Box>
								<Text onClick={overlay.hide}><IosClose size={'25px'} color={'black'}/></Text>
								<NotifcationsPanel/>
							</Box>
						</FilterOverlay>
					</Block>
				)}
			</Overlay.Container>
		)
	}
}

Notifications.propTypes = {
	updateRequestNotification: PropTypes.func
};

export default Notifications
